export default __webpack_public_path__ + "static/media/graphicdesign.68ace093.jpg";